export const paymentStatus = [
  {
    id: "1",
    name: "Completion",
  },
  {
    id: "2",
    name: "Termination (Amendment)",
  },
  {
    id: "3",
    name: "Termination (Adjustment)",
  },
  {
    id: "4",
    name: "Holding",
  },
  {
    id: "5",
    name: "On-going",
  },
  {
    id: "6",
    name: "On-going (Holding)",
  },
];

export const cat = [
  {
    id: "1",
    name: "PF",
  },
  {
    id: "2",
    name: "AOS",
  },
  {
    id: "3",
    name: "PTC",
  },
];

export const catObj = {
  1: "PF",
  2: "AOS",
  3: "PTC",
};

export const paytTerm = [
  {
    id: "1",
    name: "14",
  },
  {
    id: "2",
    name: "15",
  },
  {
    id: "3",
    name: "30",
  },
  {
    id: "4",
    name: "60",
  },
  {
    id: "5",
    name: "15일 기준 계산서 발급 시 익월 15일 입금, 이후 계산서 발급 30일 입금",
  },
  {
    id: "6",
    name: "15일 기준 계산서 발급 시 익월 15일 입금, 이후 계산서 발급 31일 입금",
  },
];

export const billingTiming = [
  {
    id: "1",
    name: "ASAP",
  },
  {
    id: "2",
    name: "Monthly",
  },
  {
    id: "3",
    name: "Monthly (업무 종료 기준)",
  },
  {
    id: "4",
    name: "Quarterly",
  },
];

export const contractType = [
  {
    id: "1",
    name: "New",
  },
  {
    id: "2",
    name: "Amendment",
  },
];

export const PTCCategory = [
  {
    id: "P01",
    name: "교통비",
  },
  {
    id: "P02",
    name: "식대",
  },
  {
    id: "P03",
    name: "Material 제작비",
  },
  {
    id: "P04",
    name: "AOS청구",
  },
  {
    id: "P05",
    name: "소모품비",
  },
  {
    id: "P06",
    name: "도서인쇄비",
  },
  {
    id: "P07",
    name: "퀵 배송비",
  },
  {
    id: "P08",
    name: "IRB심의비",
  },
  {
    id: "P09",
    name: "연구비",
  },
  {
    id: "P10",
    name: "보험료",
  },
  {
    id: "P11",
    name: "숙박료",
  },
  {
    id: "P12",
    name: "문서보관료",
  },
];

export const invPlan = [
  {
    id: 0,
    name: "",
  },
  {
    id: 1,
    name: "Hold",
  },
];

export const projectStatus = [
  {
    codeId: 1,
    name: "Completion",
  },
  {
    codeId: 2,
    name: "On-going",
  },
  {
    codeId: 3,
    name: "정산",
  },
  {
    codeId: 4,
    name: "계약해지",
  },
  {
    codeId: 5,
    name: "업무종료",
  },
];

export const paymentItem = [
  {
    id: "projStatusCodeId",
    name: "Project Status Code Id",
  },
  {
    id: "sprName",
    name: "Sponsor Name",
  },
  {
    id: "contrNo",
    name: "Contract No.",
  },
  {
    id: "SEQ",
    name: "Sequence No.",
  },
  {
    id: "cat",
    name: "Category",
  },
  {
    id: "quotNo",
    name: "Quotation No.",
  },
  {
    id: "AOSQuotNo",
    name: "AOS Quotation No.",
  },
  {
    id: "paytNo",
    name: "Payment No.",
  },
  {
    id: "paytDescr",
    name: "Payment Description",
  },
  {
    id: "totalContrCost",
    name: "Total Contract Cost",
  },
  {
    id: "costExclVAT",
    name: "Cost (Excl. VAT)",
  },
  {
    id: "costInclVAT",
    name: "Cost (Incl. VAT)",
  },
  {
    id: "projComplDate",
    name: "Project Completion Data",
  },
  {
    id: "taskComplDate",
    name: "Task Completion Date",
  },
  {
    id: "invPlan",
    name: "Invoice Plan",
  },
  {
    id: "invPlanedDate",
    name: "Invoice Planed Date",
  },
  {
    id: "invNo",
    name: "Invoice No.",
  },
  {
    id: "workStartYearMonth",
    name: "Work Period (Start)",
  },
  {
    id: "workEndYearMonth",
    name: "Work Period (End)",
  },
  {
    id: "invDate",
    name: "Invoice Date",
  },
  {
    id: "paytTerm",
    name: "Paymenet Term",
  },
  {
    id: "paytPlanedDate",
    name: "Payment Planed Date",
  },
  {
    id: "paytDate",
    name: "Payment Date",
  },
  {
    id: "overdueDate",
    name: "Overdue Date",
  },
];

export const vendorType = [
  {
    id: "1",
    name: "EDC",
  },
  {
    id: "2",
    name: "ePro",
  },
  {
    id: "3",
    name: "IWRS",
  },
  {
    id: "4",
    name: "LTFU",
  },
  {
    id: "9",
    name: "Other",
  },
];
